import React from 'react';
import { Button } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import styles from '../../../../constants/styles';
var useStyles = makeStyles(function () {
    return createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            rowGap: '20px',
            paddingTop: '20px',
        },
        button: {
            color: styles.color.socialIcons,
            minWidth: '50%',
            border: '2px solid black',
            textTransform: 'none'
        },
    });
});
export var CtaButtons = function (_a) {
    var ctaButtons = _a.ctaButtons;
    var styles = useStyles();
    return (React.createElement("div", { className: styles.container }, ctaButtons.map(function (_a) {
        var text = _a.text, link = _a.link, id = _a.id;
        return (React.createElement(Button, { key: id, "data-testid": "lib-cta-".concat(id), className: styles.button, variant: "outlined", target: "_blank", href: link }, text));
    })));
};
